import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Trailer } from '@paragon/contract-library';

interface TrailersState {
  [trailerGuid: string]: Trailer;
}

const initialState: TrailersState = {};

const trailersSlice = createSlice({
  name: 'trailers',
  initialState,
  reducers: {
    trailersLoaded: (state, action: PayloadAction<readonly Trailer[]>) => {
      for (const trailer of action.payload) {
        state[trailer.guid] = castDraft(trailer);
      }
    },
  },
});

export const { trailersLoaded } = trailersSlice.actions;
export const trailers = trailersSlice.reducer;
